import React from 'react';
import { getTeamGradient } from '../../data/teamGradients';

interface Props {
  teamCode: string;
  percent: number;
  height?: number;
  className?: string;
}

export function TeamProgressBar({ teamCode, percent, height = 6, className = '' }: Props) {
  const clamped = Math.max(0, Math.min(100, percent));
  return (
    <div
      className={`w-full bg-ink-100 rounded-pill overflow-hidden ${className}`}
      style={{ height }}
      role="progressbar"
      aria-valuenow={Math.round(clamped)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="h-full rounded-pill transition-[width] duration-progress ease-out"
        style={{ width: `${clamped}%`, background: getTeamGradient(teamCode) }}
      />
    </div>
  );
}
